/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const avalanche_chain_about = () => `Avalanche emerges as a rapid, scalable blockchain platform facilitating the seamless creation and deployment of dApps. Distinguished by its unique consensus mechanism, it's particularly good for DeFi applications, allowing high throughput and nearly instant finality. Its architecture allows for a network of interconnected blockchains, each safeguarded by dynamic subsets of validators, ensuring scalability while maintaining speed, reliability, and security.`
